import { Component } from '@angular/core';
import { FieldComponent } from 'tuain-ng-forms-lib';

@Component({
  selector: 'app-link',
  templateUrl: './app-link.component.html',
})

export class AppLinkComponent extends FieldComponent {
}
